<template>
  
    <content-header
        icona="fas fa-user-cog"
        titolo="Impostazioni utente"
    ></content-header>

    <div class="card sn-card-contenuto">
        <div class="card-body">

            <messaggio-standard 
                    :mostraMessaggio="mostraMessaggio"
                    :alertClass="alertClass"
                    :alertIcon="alertIcon"
                    :alertIconSpin="alertIconSpin"
                    :alertMessaggio="alertMessaggio"
                    fontawesome="standard"
                    ></messaggio-standard>

            <div class="container">
            <form autocomplete="off">
                <div class="row rigaSezioneForm">
                    <div class="col-md">
                        <i class="fas fa-lock text-warning"></i>&nbsp;Cambio password
                    </div>
                </div>

                <div class="mb-3">
                    <div class="form-group">
                        <label class="form-label">Nuova password</label>
                        <input type="password" class="form-control" v-model="oCambioPassword.nuovap">
                    </div>
                    <div class="form-group">
                        <label class="form-label">Conferma password</label>
                        <input type="password" class="form-control" v-model="oCambioPassword.confermap">
                    </div>
                </div>

                <div class="d-flex ">
                    <button type="button" class="btn btn-primary btn-sm" @click="SalvaPassword"><i class="fas fa-save fa-fw"></i>&nbsp;Salva</button>
                </div>

              
                
                
                
                
                
            </form>
            </div>

           
        </div>
    </div>
    
</template>

<script>
//import GrigliaFacile from '@/components/GrigliaFacile.vue';
import snFunctions from '@/lib/snFunctions.js';
import ContentHeader from '@/components/layout/ContentHeader.vue';
import MessaggioStandard from '@/components/MessaggioStandard.vue';

export default {
    name: 'ProfiloUtenteView',
    components: {
        ContentHeader, MessaggioStandard
    },
    inject: ['cfg'],
    data: function() {
        return {

            oCambioPassword: {
                username: this.$store.state.UserInfo.ute_uid,
                vecchiap: "",
                nuovap: "",
                confermap: "",
                tokenp: ""
            },

            mostraMessaggio: false,
            alertMessaggio: "",
            alertClass: "",     
            alertIcon: "",
            alertIconSpin: false
        
        }
    },
    methods: {
        ClearCambio() {
            this.oCambioPassword = {
                username: this.$store.state.UserInfo.ute_uid,
                vecchiap: "",
                nuovap: "",
                confermap: "",
                tokenp: ""
            }
        },
        ClearMessaggio() {
            this.mostraMessaggio = false;
            this.alertMessaggio =  "";
            this.alertClass = "";
            this.alertIcon = "";
            this.alertIconSpin = false;
        },
      
        SalvaPassword(reload) {
            let oSubmit = [];
            oSubmit = this.oCambioPassword;
            oSubmit.tokenp = this.$store.state.UserInfo.token;

            this.ClearMessaggio();
            fetch(this.cfg.apisrv + "/api/User/DoPasswordChange", {
                "method": "POST",
                "headers": {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(oSubmit)
            }).then(response => response.json())
                .then(obj => {
                    if (obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Impostazioni salvate.'], 'alert alert-success', 'fa-check', false, 2000]});
                        this.ClearCambio();
                    }
                    else {
                        this.$store.commit('Messaggio', {parms: [true, ['Errore salvataggio password.'], 'alert alert-danger', 'fa-times', false, 2000]});

                        this.mostraMessaggio = true;
                        this.alertMessaggio = [obj.errorMessage];
                        this.alertClass = "alert alert-warning";
                        this.alertIcon = "fa-xmark"
                        this.alertIconSpin = false

                    }
                });

      },
    
    
    },
    computed: {
        
    },
    mounted: function() {
        if(this.$store.state.UserInfo.token == '') this.$router.push("/");
      
     

    }
}
</script>